(function () {
  var size = $(".lunzhunyezi-bottom-item").length;
  var index = 0;
  var interval = setInterval(function () {
    index++;
    if (index >= size) {
      index = 0;
    }
    $(".lunzhunyezi-bottom-item").eq(index).addClass("active").siblings().removeClass("active");
  }, 2000);
  $(".lunzhunyezi-bottom-item").mouseover(function () {
    clearInterval(interval);
    $(this).addClass("active").siblings().removeClass("active");
  });

  $(".lunzhunyezi-bottom-item").mouseout(function () {
    interval = setInterval(function () {
      index++;
      if (index >= size) {
        index = 0;
      }
      $(".lunzhunyezi-bottom-item").eq(index).addClass("active").siblings().removeClass("active");
    }, 2000);
  });
})();

